import FileUpload from "../../DesignSystem/Upload/FileUpload";
import UploadedFileList from "../../DesignSystem/Upload/UploadedFileList";

const ReceivedReferenceUpload = ({ files = [], onChange }) => (
  <div className="fit-column gap-s">
    <FileUpload
      label="Reference received files"
      description="Drag & drop the received reference here or"
      browseText="Browse"
      accept=".pdf,.doc,.docx,.png,.jpg,.jpeg,.eml,.msg"
      multiple
      files={files}
      onFilesChange={(selected) =>
        onChange([...files, ...(Array.isArray(selected) ? selected : [selected]).filter(Boolean)])
      }
    />
    <UploadedFileList
      files={files}
      canRemove={(file) => file instanceof File}
      onRemove={(file) => onChange(files.filter((item) => item !== file))}
    />
  </div>
);

export default ReceivedReferenceUpload;
